'use client';

import React from "react";
import { OrgSettingsPage } from "./OrgSettingsPage";
import { OrgContext, defaultCopy } from "./internals";
import { ToastProvider } from "./components/Toaster";

/**
 * @aumonline/org-settings — portable Organisation Settings module.
 *
 * Host injects everything; this module imports nothing outside itself.
 *
 * Props:
 *  - storage:     ORG_SETTINGS_STORAGE_INTERFACE (required)
 *  - currentUser: { role }  — gates editing to owner/admin
 *  - copy:        optional copy overrides
 *  - onSaved:     called after any successful save/upload so the host
 *                 can refresh its own copy of the org (name/logo/address)
 */
export const OrgSettingsModule = ({ storage, currentUser, copy, onSaved, onCancel }) => {
  if (!storage) throw new Error("<OrgSettingsModule> requires a `storage` prop.");
  const value = React.useMemo(
    () => ({
      storage,
      currentUser: currentUser || {},
      copy: { ...defaultCopy, ...(copy || {}) },
      onSaved: onSaved || (() => {}),
      onCancel: onCancel || null,
    }),
    [storage, currentUser, copy, onSaved, onCancel]
  );
  return (
    <OrgContext.Provider value={value}>
      <ToastProvider>
        <OrgSettingsPage />
      </ToastProvider>
    </OrgContext.Provider>
  );
};

export default OrgSettingsModule;
